import React, { useContext } from 'react';
import { string } from 'prop-types';
import { AppContext } from '../../../context/listingsContext';
import { VIEW_ALL_COMPONENT } from '../../top_filters_carousel/constants';
import ViewAllTile from '../view_all_tile/viewAllTile';
import view_all from '../filter_tile/images/view_all.svg';
import { LIST_TYPES } from '../view_all_tile/constants';
import { CarouselContext } from '../../sc_tiles_carousel';
import { handleClick, transformScItems, sortByMostSignificant } from './utils';
import '../index.scss';

const ScTile = ({ id, alias, url, src }) => {
    const { dispatch, filter: { subCategory }, significantLeafCategories = [] } = useContext(AppContext);
    const { setCollapseCarousel } = useContext(CarouselContext);

    if (id === VIEW_ALL_COMPONENT) {
        const scItems = transformScItems(subCategory.children);
        const sortedScItems = sortByMostSignificant(scItems, significantLeafCategories);

        return (
            <ViewAllTile items={sortedScItems}
                image={view_all}
                alias={alias}
                listType={LIST_TYPES.SUBCATEGORIES}/>
        );
    }

    return (
        <a href={url} className="tile box-shadow-z2"
            onClick={() => handleClick({ setCollapseCarousel, subCategory, selected: id, dispatch })}>
            <img src={src} alt={alias} loading="lazy"/>
            <p className="text-body-2">{alias}</p>
        </a>
    );
};

ScTile.propTypes = {
    id: string,
    alias: string,
    url: string,
    src: string
};

export default ScTile;
